<button
      [disabled]="disabled() || loading()"
      (click)="handleClick($event)"
      [ngClass]="getClasses()"
      class="w-full flex items-center justify-center gap-2 font-semibold transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed h-[52px]">

      <!-- Loading Spinner -->
      @if (loading()) {
        <span class="animate-spin h-5 w-5 border-2 border-current border-t-transparent rounded-full"></span>
      } @else {
        @if (icon()) {
          <lucide-icon [name]="icon()" [class]="iconSize()"></lucide-icon>
        }
        <!-- Content Projection (Texto/Iconos) -->
        <ng-content></ng-content>
      }
    </button>
